import React from "react";

import ArrowLeftIcon from "@uui/ArrowLeft";

import { Typography } from "@mui/material";

import Button from "@rui/Button";
import { Link, LinkProps } from "@rui/Link";
import LogomarkWithGradient from "@rui/LogomarkWithGradient";
import { Row } from "@rui/Stack";

const ExitCheckoutButton = ({
  children,
  to,
}: {
  children: React.ReactNode;
  to: LinkProps["to"];
}) => {
  return (
    <Link to={to} replace>
      <Button
        startIcon={<ArrowLeftIcon />}
        variant="text"
        sx={{
          color: "#FFF",
          "&:hover": { bgcolor: "transparent.black.8" },
          "& .MuiSvgIcon-root": { fontSize: "16px" },
        }}
      >
        <Row variant="left" spacing={1}>
          <LogomarkWithGradient
            sx={{
              height: "24px",
              width: "24px",
              padding: "3px",
              borderRadius: "2px",
            }}
          />
          <Typography variant="bodySecondaryMed">{children}</Typography>
        </Row>
      </Button>
    </Link>
  );
};

export default ExitCheckoutButton;
